// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logout-container {
  min-height: 100%;
  background-attachment: fixed;
  background-image: url("/assets/images/background-pattern.svg"), linear-gradient(rgb(0, 158, 218), rgb(0, 124, 190));
  height: 100%;
  overflow: auto;
}
.logout-container .container {
  padding-bottom: 50px;
}

#nice-img {
  width: 100px;
  height: 70px;
  padding-top: 30px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

#status-completed{
  padding-top: 40px;
  padding-bottom: 32px;
}

#status-completed-img {
  width: 64px;
  height: 64px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

#logout-message {
  padding-bottom: 24px;
}

#logout-message-p {
  text-align: center;
  height: 45px;
  margin: 0;
  display : flex;
  align-items : center;
  justify-content : center;
}

#btnGoLoginPage{
  margin:0;
  font-family: "Open Sans";
  font-size: 14px;
  border-radius: 3px;
  text-decoration: none;
  box-sizing: border-box;
  min-width: 110px;
  height: 40px;
}

.card {
  margin-top: 24px;
  width: 350px;
  height: 284px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}

footer.copyRight-contactUs {
  color: #fff;
  text-align: center;
  width: 100%;
  display: block;
  padding: 0;
  margin: -50px auto 0;
  height: 50px;
}

.vertical-center {
  min-height: 100%;  /* Fallback for vh unit */
  min-height: 100vh; /* You might also want to use
                        'height' property instead.

                        Note that for percentage values of
                        'height' or 'min-height' properties,
                        the 'height' of the parent element
                        should be specified explicitly.

                        In this case the parent of '.vertical-center'
                        is the <body> element */

  /* Make it a flex container */
  display: flex;

  /* Align the bootstrap's container vertically */
  align-items : center;

  /* In legacy web browsers such as Firefox 9
     we need to specify the width of the flex container */
  width: 100%;

  /* Also 'margin: 0 auto' doesn't have any effect on flex items in such web browsers
     hence the bootstrap's container won't be aligned to the center anymore.

     Therefore, we should use the following declarations to get it centered again */
  justify-content : center;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/logout-page/logout-page.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,mHAAmH;EACnH,YAAY;EACZ,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB,GAAG,yBAAyB;EAC5C,iBAAiB,EAAE;;;;;;;;;+CAS0B;;EAE7C,6BAA6B;EAK7B,aAAa;;EAEb,+CAA+C;EAK/C,oBAAoB;;EAEpB;yDACuD;EACvD,WAAW;;EAEX;;;mFAGiF;EAKjF,wBAAwB;AAC1B","sourcesContent":[".logout-container {\n  min-height: 100%;\n  background-attachment: fixed;\n  background-image: url(\"/assets/images/background-pattern.svg\"), linear-gradient(rgb(0, 158, 218), rgb(0, 124, 190));\n  height: 100%;\n  overflow: auto;\n}\n.logout-container .container {\n  padding-bottom: 50px;\n}\n\n#nice-img {\n  width: 100px;\n  height: 70px;\n  padding-top: 30px;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n#status-completed{\n  padding-top: 40px;\n  padding-bottom: 32px;\n}\n\n#status-completed-img {\n  width: 64px;\n  height: 64px;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n#logout-message {\n  padding-bottom: 24px;\n}\n\n#logout-message-p {\n  text-align: center;\n  height: 45px;\n  margin: 0;\n  display : flex;\n  align-items : center;\n  justify-content : center;\n}\n\n#btnGoLoginPage{\n  margin:0;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  border-radius: 3px;\n  text-decoration: none;\n  box-sizing: border-box;\n  min-width: 110px;\n  height: 40px;\n}\n\n.card {\n  margin-top: 24px;\n  width: 350px;\n  height: 284px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 50px;\n}\n\nfooter.copyRight-contactUs {\n  color: #fff;\n  text-align: center;\n  width: 100%;\n  display: block;\n  padding: 0;\n  margin: -50px auto 0;\n  height: 50px;\n}\n\n.vertical-center {\n  min-height: 100%;  /* Fallback for vh unit */\n  min-height: 100vh; /* You might also want to use\n                        'height' property instead.\n\n                        Note that for percentage values of\n                        'height' or 'min-height' properties,\n                        the 'height' of the parent element\n                        should be specified explicitly.\n\n                        In this case the parent of '.vertical-center'\n                        is the <body> element */\n\n  /* Make it a flex container */\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n\n  /* Align the bootstrap's container vertically */\n  -webkit-box-align : center;\n  -webkit-align-items : center;\n  -moz-box-align : center;\n  -ms-flex-align : center;\n  align-items : center;\n\n  /* In legacy web browsers such as Firefox 9\n     we need to specify the width of the flex container */\n  width: 100%;\n\n  /* Also 'margin: 0 auto' doesn't have any effect on flex items in such web browsers\n     hence the bootstrap's container won't be aligned to the center anymore.\n\n     Therefore, we should use the following declarations to get it centered again */\n  -webkit-box-pack : center;\n  -moz-box-pack : center;\n  -ms-flex-pack : center;\n  -webkit-justify-content : center;\n  justify-content : center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
